function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP title
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import { placeOfBirth } from '../../actions/index';
import Select from '../select/Select';
import { COUNTRIES } from '../../data/Data';
import './PlaceOfBirth.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export class PlaceOfBirth extends React.Component {
  render() {
    const {
      placeOfBirth,
      setPlaceOfBirth
    } = this.props;
    return /*#__PURE__*/_jsx(Select, {
      handleChange: setPlaceOfBirth,
      label: "Country of birth",
      options: COUNTRIES,
      onBlur: setPlaceOfBirth,
      name: "placeOfBirth",
      section: "personal-details"
      // $FlowFixMe
      ,
      values: {
        placeOfBirth
      }
    });
  }
}
_defineProperty(PlaceOfBirth, "defaultProps", {
  placeOfBirth: {
    value: ''
  }
});
const mapStateToProps = ({
  placeOfBirth
}) => {
  return {
    placeOfBirth
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setPlaceOfBirth: value => {
      dispatch(placeOfBirth(value));
    }
  };
};
const VisiblePlaceOfBirth = connect(mapStateToProps, mapDispatchToProps)(PlaceOfBirth);
export default VisiblePlaceOfBirth;